
import { Hero } from "@/components/Hero";

interface SearchSectionProps {
  onSearch: (query: string) => void;
}

export const SearchSection = ({ onSearch }: SearchSectionProps) => {
  return (
    <div className="flex flex-col">
      <Hero onSearch={onSearch} />
    </div>
  );
};
